registerGlobal( 'ServerOverride' );
ServerOverride.url = ServerOverride.url || "://hc-game-ws-dev.huuuge.net:1044";

ServerOverride.getServerAddress = function() {
    var len= ServerOverride.url.length;
    var heapP = _malloc( len + 1);
    stringToUTF8( ServerOverride.url, heapP, len+1 );
    return heapP;
}

ServerOverride.isProdServer = function() {
    var url = ServerOverride.url;
    if ( url.indexOf("game-ws.huuugecasino.net") != -1) {
        return 1;
    }
    return 0;
}



//////////////////
// WEBPACK FOOTER
// /src/src/platform/emscripten/Application.server.js
// module id = 25
// module chunks = 0